const SENHA_VAZADA = 'Esta senha aparece em vazamentos conhecidos. Escolha outra.'

const traduzir = mensagem => {
  if (/data leak/i.test(mensagem)) {
    return SENHA_VAZADA
  }
  return mensagem
}

// Monta a mensagem de erro de uma resposta da API, incluindo os erros de validação (422) do Laravel.
export const mensagemErroApi = (error, padrao = 'Ocorreu um erro durante a operação!') => {
  const data = error?.response?.data || {}
  if (data.errors && typeof data.errors === 'object') {
    const mensagens = Object.values(data.errors).flat().map(traduzir)
    if (mensagens.length) {
      return mensagens.join('\n')
    }
  }
  if (error?.response?.status === 403) {
    return data.mensagem || data.message || 'Acesso restrito aos administradores.'
  }
  return traduzir(data.mensagem || data.message || padrao)
}

export default mensagemErroApi
